import React, { useState, useEffect } from "react";
import "./ShopCard.css";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function ShopCard(props) {
  const navigate = useNavigate();
  const handleCategoryClick = () => {
    props.onShopCardClick();
  };

  const handleRemoveFavorite = (event) => {
    event.stopPropagation();
    props.onFavoriteRemove();
  };

  const handleOpenMagazine = (event) => {
    event.stopPropagation();
    console.log("click shod");
    navigate("/magazine", { state: { magazineId: props.journal } });
  };

  return (
    <div className="shopCard centeredFlex" onClick={handleCategoryClick}>
        <div
        className="shopCardCover"
      >
        <LazyLoadImage
          width="100%"
          height="100%"
          src={props.cover || "/images/bgLogo.svg"} 
          alt={props.name || props.title || "product"}
          effect="opacity"
          placeholderSrc="/images/bgLogo.svg"
          style={{
            borderRadius: "0.5rem",
          }}
          onError={({ target }) => {
            target.onerror = null; 
            target.src = "/images/bgLogo.svg";
          }}
        />
      </div>
      <div className="shopCardContent centeredFlex">
        {props.label === "favorites" ? (
          <div className="favoriteProductCardTitle centeredFlex">
            <p>{props.label === "category" ? props.name : props.title}</p>
            <CloseIcon onClick={handleRemoveFavorite} />
          </div>
        ) : (
          <p className="productCardTitle">
            {props.label === "category" ? props.name : props.title}
          </p>
        )}
        {props.label === "partialProduct" && (
          <div className="productCardData">
            <div className="productCardPriceWrapper centeredFlex">
              <div className="productCardPrice centeredFlex">
                <span>{props.price.toLocaleString()}</span>
              </div>
              <p className="productCardUnit">تومان</p>
            </div>
            <div className="quantityAndJournal centeredFlex">
              <div className="productCardQuantity">
                <span>{props.quantity}</span> عدد موجود در انبار
              </div>
              {props.journal && (
                <div
                  className="productJournalBtn centeredFlex"
                  onClick={handleOpenMagazine}
                >
                  <span>خواندن مجله</span>
                </div>
              )}
            </div>
            {props.detail && (
              <p className="productCardDetail">{props.detail}</p>
            )}
          </div>
        )}
        {props.label === "favorites" && (
          <div className="productCardData">
            <div className="productCardPriceWrapper centeredFlex">
              <div className="favoriteProductCardPrice centeredFlex">
                <span>{props.price.toLocaleString()}</span>
              </div>
              <p className="productCardUnit">تومان</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
